import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../redux/authSlice";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { useTipoDocumento } from "../../../hooks_cache/useTipoDocumento";

import { Link } from "react-router-dom";

const MySwal = withReactContent(Swal);

const showProfileModal = (user, tipoDocumento) => {
  const { name, email, id_tipoDocumento, numDocument } = user;
  MySwal.fire({
    title: "Editar Mi Perfil",
    html: (
      <form id="profile-form">
        <div className="form-floating mb-3">
          <input type="text" className="form-control fs-15px" placeholder="Nombre" name="nombre" defaultValue={name} required />
          <label className="d-flex align-items-center fs-13px">Nombre</label>
        </div>

        <div className="form-floating mb-3">
          <input type="email" className="form-control fs-15px" placeholder="Correo" name="correo" defaultValue={email} required />
          <label className="d-flex align-items-center fs-13px">Correo</label>
        </div>

        <div className="form-floating mb-3">
          <select id="id_tipoDocumento" name="id_tipoDocumento" className="form-select" required defaultValue={id_tipoDocumento}>
            <option value="">Seleccione un tipo</option>
            {tipoDocumento?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.descripcion}
              </option>
            ))}
          </select>
          <label className="d-flex align-items-center fs-13px" htmlFor="id_tipoDocumento">
            Tipo de Documento:
          </label>
        </div>

        <div className="form-floating mb-3">
          <input type="text" id="numDocument" name="numDocument" defaultValue={numDocument} className="form-control fs-15px" required />
          <label className="d-flex align-items-center fs-13px" htmlFor="numDocument">
            Documento:
          </label>
        </div>
      </form>
    ),
    showCancelButton: true,
    confirmButtonText: "Guardar",

    preConfirm: () => {
      const form = document.getElementById("profile-form");
      const formData = new FormData(form);
      const data = Object.fromEntries(formData.entries());

      console.log("Form Data Submitted:", data);
      return data;
      // Aquí puedes agregar la lógica para enviar los datos del formulario a un servidor
    },
  });
};

function DropdownProfile() {
  const { data: tipoDocumento } = useTipoDocumento();

  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logout());
  };

  const user = useSelector((state) => state.auth.user);

  return (
    <div className="navbar-item navbar-user dropdown">
      <a href="#/" className="navbar-link dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown">
        <div className="image image-icon bg-gray-800 text-gray-600">
          <i className="fa fa-user"></i>
        </div>
        <span>
          <span className="d-none d-md-inline">{user?.name || "Invitado"}</span>
          <b className="caret"></b>
        </span>
      </a>
      <div className="dropdown-menu dropdown-menu-end me-1">
        <button className="dropdown-item" onClick={() => showProfileModal(user, tipoDocumento)}>
          Editar Perfil
        </button>

        <Link to="/company" className="dropdown-item">
          Configuracion
        </Link>

        <div className="dropdown-divider"></div>
        <button onClick={handleLogout} className="dropdown-item btn-link">
          Salir
        </button>
      </div>
    </div>
  );
}

export default DropdownProfile;
